<div class="customer-contracts">
  <div *ngIf="!isInAddMode">
    <div style="width: 25%">
      <div style="margin-top: 0.5em; float: right">
        <button (click)="onAddClick()">{{ 'label.AddNew' | translate }}</button>
      </div>
    </div>
    <h3>Current Contract</h3>
    <div *ngFor="let item of customerContracts">
      <div *ngIf="item.isActive">
        <button
          (click)="onDelete(item.customerContractId)"
          style="display: contents; color: red"
        >
          <i class="fa fa-trash fa-lg" aria-hidden="true"></i></button
        >&nbsp; <span>{{ item?.type?.name }}</span
        >&nbsp;
        <span>{{ item?.expireDate | date : dateFormat }}</span>
        <a *ngIf="item?.fileName" href="{{ item?.fileName }}"
          >({{ 'label.Download' | translate }})</a
        >
      </div>
      <br />
    </div>
    <div *ngIf="hasOldContracts" style="margin-top: 2em">
      <p-accordion [style]="{ width: '15%' }">
        <p-accordionTab header="Old Contracts">
          <div *ngFor="let item of customerContracts">
            <div *ngIf="!item.isActive">
              <span>{{ item?.type?.name }}</span>
              <span>{{ item?.expireDate | date : dateFormat }}</span>
              <a *ngIf="item?.fileName" href="{{ item?.fileName }}"
                >({{ 'label.Download' | translate }})</a
              >
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
  <div *ngIf="isInAddMode" class="add-block">
    <div>
      <div>{{ 'label.Type' | translate }}:</div>
      <div>
        <select
          name="contractTypes"
          [ngModel]="
            newContract &&
            newContract.type &&
            newContract.type.customerContractTypeId
          "
          (ngModelChange)="
            newContract &&
              newContract.type &&
              (newContract.type.customerContractTypeId = $event)
          "
        >
          <option
            *ngFor="let item of contractTypes"
            [value]="item.value"
            [selected]="item.value == newContract?.type?.customerContractTypeId"
          >
            {{ item.text }}
          </option>
        </select>
        <hr-field-state-marker [field]="field?.type"></hr-field-state-marker>
      </div>
    </div>
    <div>
      <div>
        {{ 'label.Deadline' | translate }}
      </div>
      <div>
        <p-datepicker
          [ngModel]="newContract && newContract.expireDate"
          (ngModelChange)="newContract && (newContract.expireDate = $event)"
          [showIcon]="true"
        ></p-datepicker>
        <hr-field-state-marker
          [field]="field?.expireDate"
        ></hr-field-state-marker>
      </div>
    </div>
    <div>
      <div></div>
      <div>
        <label class="upload-button">
          <input
            type="file"
            ngFileSelect
            [options]="uploadOptions"
            [uploadInput]="uploadInput"
            (uploadOutput)="onUploadOutput($event)"
          />
        </label>
      </div>
    </div>
    <div>
      <div>
        <button
          (click)="onSaveClick()"
          [disabled]="attachmentUploadErrorOccured"
        >
          {{ 'label.Save' | translate }}
        </button>
      </div>
      <div>
        <button (click)="onCancelClick()">
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
